import { render } from "./MyBookingInfo.vue?vue&type=template&id=06ea7cda&scoped=true&lang=pug"
import script from "./MyBookingInfo.vue?vue&type=script&lang=ts"
export * from "./MyBookingInfo.vue?vue&type=script&lang=ts"

import "./MyBookingInfo.vue?vue&type=style&index=0&id=06ea7cda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06ea7cda"

export default script